import {
  arrayOf,
  params,
  string as stringType,
  shape as shapeType,
  number as numberType,
  customType
} from '@thd-nucleus/data-sources';

const Tools = customType('RentalInformation_getRentalEstimate_EstimateToolRequest').shape({
  categoryCode: stringType(),
  subCategoryCode: stringType()
});

const Address = customType('RentalInformation_getRentalEstimate_EstimateAddressRequest').shape({
  street: stringType(),
  city: stringType(),
  stateProvince: stringType(),
  postalCode: stringType(),
  countryCode: stringType()
});

const Delivery = customType('RentalInformation_getRentalEstimate_EstimateDeliveryRequest').shape({
  address: Address
});

export const GET_RENTAL_ESTIMATE_DATA_MODEL = {
  getRentalEstimate: params({
    pickupTime: stringType(),
    returnTime: stringType(),
    store: stringType(),
    tools: arrayOf(Tools),
    svocId: stringType()
  }).mutation().shape({
    fees: arrayOf(
      shapeType({
        percentage: numberType(),
        taxPercentage: numberType(),
        taxTotal: numberType(),
        taxes: arrayOf(
          shapeType({
            value: numberType(),
            percentage: numberType(),
            type: stringType()
          })
        ),
        type: stringType(),
        value: numberType()
      })
    ),
    tools: arrayOf(
      shapeType({
        categoryCode: stringType(),
        deposit: numberType(),
        discountedDeposit: numberType(),
        feeTotal: numberType(),
        fees: arrayOf(
          shapeType({
            percentage: numberType(),
            taxPercentage: numberType(),
            taxTotal: numberType(),
            taxes: arrayOf(
              shapeType({
                value: numberType(),
                percentage: numberType()
              })
            ),
            type: stringType(),
            value: numberType()
          })
        ),
        subCategoryCode: stringType(),
        taxPercentage: numberType(),
        taxTotal: numberType()
      })
    ),
    totals: shapeType({
      totalDamageWaiver: numberType(),
      totalDamageWaiverTax: numberType(),
      totalDamageWaiverWithTax: numberType(),
      totalDeposit: numberType(),
      totalDiscountedDeposit: numberType(),
      totalEstimate: numberType(),
      totalEstimateTax: numberType(),
      totalEstimateWithoutDamageWaiver: numberType(),
      totalEstimateWithoutDamageWaiverTax: numberType(),
      totalEstimateWithoutDamageWaiverWithTax: numberType(),
      totalEstimateWithTax: numberType(),
      totalFees: numberType(),
      totalFeesTax: numberType(),
      totalFeesWithTax: numberType(),
      totalTools: numberType(),
      totalToolsTax: numberType(),
      totalToolsWithTax: numberType()
    })
  })
};

export const GET_RENTAL_DELIVERY_ESTIMATE_DATA_MODEL = {
  getRentalEstimate: params({
    pickupTime: stringType(),
    returnTime: stringType(),
    tools: arrayOf(Tools),
    delivery: Delivery,
    svocId: stringType()
  }).mutation().shape({
    fees: arrayOf(
      shapeType({
        percentage: numberType(),
        taxPercentage: numberType(),
        taxTotal: numberType(),
        taxes: arrayOf(
          shapeType({
            value: numberType(),
            percentage: numberType(),
            type: stringType()
          })
        ),
        type: stringType(),
        value: numberType()
      })
    ),
    tools: arrayOf(
      shapeType({
        categoryCode: stringType(),
        deposit: numberType(),
        discountedDeposit: numberType(),
        feeTotal: numberType(),
        fees: arrayOf(
          shapeType({
            percentage: numberType(),
            taxPercentage: numberType(),
            taxTotal: numberType(),
            taxes: arrayOf(
              shapeType({
                value: numberType(),
                percentage: numberType()
              })
            ),
            type: stringType(),
            value: numberType()
          })
        ),
        subCategoryCode: stringType(),
        taxPercentage: numberType(),
        taxTotal: numberType()
      })
    ),
    totals: shapeType({
      totalDamageWaiver: numberType(),
      totalDamageWaiverTax: numberType(),
      totalDamageWaiverWithTax: numberType(),
      totalDeposit: numberType(),
      totalDiscountedDeposit: numberType(),
      totalEstimate: numberType(),
      totalEstimateTax: numberType(),
      totalEstimateWithoutDamageWaiver: numberType(),
      totalEstimateWithoutDamageWaiverTax: numberType(),
      totalEstimateWithoutDamageWaiverWithTax: numberType(),
      totalEstimateWithTax: numberType(),
      totalFees: numberType(),
      totalFeesTax: numberType(),
      totalFeesWithTax: numberType(),
      totalTools: numberType(),
      totalToolsTax: numberType(),
      totalToolsWithTax: numberType()
    })
  })
};